import fetch from 'utils/fetch';


export function productList(productId,productName,agent,providerId,zoneName,psize,currentPage,
                            bossId,providerList,ccList,onSale,isOta,productCode,target,selectAccount,accountType) {
    console.log(productId,productName,agent,providerId,zoneName,psize,currentPage,
        bossId,providerList,ccList,onSale,isOta,productCode,target,selectAccount,accountType);
    const data = {
        productId,
        productName,
        agent,
        providerId,
        zoneName,
        psize,
        currentPage,
        bossId,
        providerList,
        ccList,
        onSale,
        isOta,
        productCode,
        target,
        selectAccount,
        accountType
    };
    return fetch({
        url: '/productList',
        method: 'get',
        params:data
    });
}
export function productDetails(productId) {
    return fetch({
        url: '/productDetail',
        method: 'get',
        params : {productId}
    });
}
export function withdrawPackage(params) {
    const data = {
        'account':params.account,
        'tId':params.tId,
        'splitTid':params.splitTid,
        'otwProductId':params.otwProductId,
    };
    return fetch({
        url: '/withdrawPackage',
        method: 'post',
        data
    });
}
export function providerList() {
    return fetch({
        url: '/providerList',
        method: 'get'
    });
}
export function bossList() {
    return fetch({
        url: '/bossList',
        method: 'get'
    });
}
export function countryList() {
    return fetch({
        url: '/countryList',
        method: 'get'
    });
}
export function addProduct(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/addProduct',
        method: 'post',
        data
    });
}


export function upProduct(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/editProduct',
        method: 'put',
        data
    });
}
export function delProduct(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/delProduct',
        method: 'post',
        data
    });
}
export function batchDelProduct(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/batchDelProduct',
        method: 'post',
        data
    });
}



// WEBPACK FOOTER //
// ./src/api/product.js